<template>
  <div>
    <div
      class="page-content"
      itemscope
      itemtype="https://schema.org/Product">
      <div class="offer clearfix">
        <div class="offer-sidebar">
          <h2>
            <svgicon
              name="purse"
              width="19"
              height="18"
              class="icon-balance"/>
            Оформить заказ
          </h2>

          <buyOffer
            v-if="offer"
            :id="offer.id"
            :key="offer.id"
            :title="offer.name + ' ' + offer.name_user"
            :attributes="offer.attrs"
            :custom-attributes="offer.customAttrs ? offer.customAttrs : []"
            :price="offer.price"
            :total-price="offer.totalPrice"
            :total-time="offer.totalTime"
            :minimum-sum="offer.minimum_sum"
            :is-instant-delivery="(offer.category.is_instant_delivery && offer.time == 0) ? true : false
            "
            :show-count="
              offer.category.show_count == 1 && offer.category.show_price == 1
            "
            :show-price="offer.category.show_price == 1 ? true : false"
            :show-time="offer.category.show_time == 1 ? true : false"
            :price-multiplier="offer.category.price_multiplier"
            :max-count="offer.count"/>
        </div>
        <div class="offer-content">
          <template v-if="offer">
            <div class="d-flex offer-header">
              <img
                :src="
                  backendUrl +
                    '/img/game/' +
                    offer.game.icon +
                    '?v=' +
                    offer.game.updated_at
                ">
              <div class="d-flex flex-direction-column">
                <nuxt-link
                  :to="
                    '/games/' +
                      offer.game.id +
                      '-' +
                      slugify(offer.game.name) +
                      '/' +
                      offer.category.id +
                      '-' +
                      slugify(offer.category.name) +
                      '/'
                  ">
                  {{ offer.category.name }}
                </nuxt-link>
                <h1
                  class="fs-14"
                  itemprop="name"
                  :content="
                    offer.category.name +
                      ' ' +
                      offer.game.name +
                      ' ' +
                      offer.name +
                      ' ' +
                      offer.name_user
                  ">
                  {{ offer.name + " " + offer.name_user }}
                </h1>
              </div>
            </div>

            <div class="offer-user">
              <div class="user-content">
                <rating
                  itemprop="aggregateRating"
                  itemscope
                  itemtype="https://schema.org/AggregateRating"
                  :value="
                    offer.user.rating == null
                      ? null
                      : offer.user.rating.toString()
                  "
                  :reviews-count="parseInt(offer.user.reviewsCount)"
                  class="seller-rating"/>
                <user
                  :id="parseInt(offer.user.id)"
                  :avatar="offer.user.photo"
                  :name="offer.user.username"
                  :premium="offer.user.premium_expired_at"
                  :status="offer.user.online == true"
                  @change-online="handleUserChangeOnline"/>
                <button
                  class="btn btn-outline-secondary user-feedback"
                  @click="startChat(offer.user.id)">
                  <svgicon
                    name="dialogs"
                    width="16"
                    height="12"
                    class="icon-feedback"/>
                  Написать продавцу
                </button>
              </div>
              <div class="user-timings">
                <div 
                  v-if="chatUserInfo && chatUserInfo.anotherUser && chatUserInfo.anotherUser.disconnectedAt && !chatUserInfo.anotherUser.online"
                  class="user-disconnected-at">
                  Был в сети
                  <timeago
                    :datetime="new Date(chatUserInfo.anotherUser.disconnectedAt * 1000).toISOString()" 
                    :auto-update="60"/>
                </div>
                <div class="user-time">
                  На сайте с {{ offer.user.created_at }}
                </div>
              </div>
            </div>

            <div class="properties">
              <div
                v-if="offer.count && offer.count != null"
                class="property">
                <span>Товара в наличии</span>
                {{ offer.count >= 0 ? offer.count : "Неограниченно" }}
              </div>
              <div
                v-if="offer.category.show_time && offer.category.show_time == 1 && offer.time != null"
                class="property">
                <span>Срок выполнения:</span>
                <template v-if="offer.category.is_instant_delivery && offer.time == 0">
                  <span class="d-flex justify-content-flex-end">
                    <svgicon
                      name="flash"
                      width="10"
                      height="20"
                      class="mr-8"/>Мгновенно
                  </span>
                </template>
                <template v-else>
                  {{ offer.time }} минут
                </template>
              </div>
              <div
                v-for="(attribute, index2) in offer.contentAttrs"
                :key="index2"
                class="property">
                <span>{{ attribute.name }}</span>
                <template
                  v-if="!attribute.after_buy || attribute.after_buy == 0">
                  <template v-if="attribute.type == 0">
                    {{ parseInt(attribute.content) === 1 ? "Да" : "Нет" }}
                  </template>
                  <template v-else>
                    {{ attribute.content }}
                  </template>
                </template>
                <template v-else>
                  <div class="d-flex">
                    <div>••••••••</div>
                    <svgicon
                      v-b-popover.hover.top="
                        offer.time == 0
                          ? 'Доступно после покупки'
                          : 'Продавец свяжется с вами в чате и передаст все данные'
                      "
                      name="shield"
                      class="ml-4"
                      width="18"
                      height="22"/>
                  </div>
                </template>
              </div>
            </div>
            <div
              v-linkified
              itemprop="description"
              class="description"
              v-html="offer.description"/>
            <client-only v-if="showMedia">
              <div class="offer-media">
                <div v-swiper:mySwiper="swiperOption">
                  <div class="swiper-wrapper">
                    <div
                      v-for="(item, imageIndex) in lightboxMedia"
                      :key="imageIndex"
                      class="image offer-media-file swiper-slide">
                      <img
                        class="svg-icon"
                        src="/img/show.png"
                        @click="setIndex(imageIndex)">
                      <img
                        v-if="item.type != 1"
                        class="svg-icon-video"
                        src="/img/substract.png"
                        @click="setIndex(imageIndex)">
                      <img
                        v-if="item.type == 1"
                        :src="item.thumb"
                        @click="setIndex(imageIndex)">
                      <video
                        v-if="item.type == 2"
                        @click="setIndex(imageIndex)">
                        <source :src="item.src">
                        Ваш браузер не поддерживает видео
                      </video>
                      <img
                        v-if="item.type == 3"
                        :src="item.thumb"
                        @click="setIndex(imageIndex)">
                    </div>
                  </div>
                </div>
              </div>
            </client-only>
          </template>
        </div>
      </div>
    </div>
    <CoolLightBox
      :items="lightboxMedia"
      :index="index"
      loop
      @close="index = null"/>
    <div class="reviews">
      <reviews
        v-if="offer && offer.user"
        :reviews="reviews"
        :show-order-id="false"
        :show-table-head="false"
        :show-nav="false"
        :show-id="false"
        :show-edit="false"
        :show-header="true"
        :show-buyer="true"
        :update-entity="true"
        :show-reviews-count="false"
        :show-price="true"
        :user-id="parseInt(offer.user.id)"/>
    </div>
  </div>
</template>

<script>
import "~/icons/dialogs";
import "~/icons/purse";
import "~/icons/deal";
import "~/icons/medal";
import "~/icons/stream";
import "~/icons/flash";
import "~/icons/image";
import "~/icons/reviews";
import "~/icons/shield";
import "~/icons/info-circle";
import user from "~/components/base/user.vue";
import "vue-cool-lightbox/dist/vue-cool-lightbox.min.css";
import "swiper/dist/css/swiper.css";
import rating from "~/components/base/rating.vue";
import buyOffer from "~/components/offer/calculate/buy.vue";
import reviews from "~/components/profile/reviews.vue";
import { mapGetters, mapState, mapActions } from "vuex";
import axios from "axios/index";
import {
  contentAttributes,
  calculateAttributes,
} from "~/services/offerAttributes";
import { getDate, getPhoto } from "~/services/base";
import { prepareAttributesCalculateOffer } from "~/services/prepareAttributesCalculateOffer";
import Vue from "vue";
if (process.browser) {
  const VueAwesomeSwiper = require("vue-awesome-swiper/dist/ssr");
  Vue.use(VueAwesomeSwiper);
}

import linkify from "vue-linkify";

Vue.directive("linkified", linkify);

export default {
  components: {
    rating,
    buyOffer,
    user,
    reviews,
  },
  head() {
    return {
      title: `Купить ${this.offer.category.name} ${this.offer.game.name} ${this.offer.name} ${this.offer.name_user} | GoBuffy.com`,
      meta: [
        {
          hid: `og:title`,
          name: "og:title",
          content: `Купить ${this.offer.category.name} ${this.offer.game.name} ${this.offer.name} ${this.offer.name_user} | GoBuffy.com`,
        },
        {
          hid: `description`,
          name: "description",
          content: `Покупайте ${this.offer.category.name} ${this.offer.game.name} ${this.offer.name} ${this.offer.name_user} на GoBuffy.com. Система защиты покупателей GOBUFFY SHIELD, система споров, возврат средств, верификация продавцов и другие функции делают вашу покупку безопасной.`,
        },
        {
          hid: `og:description`,
          name: "og:description",
          content: `Покупайте ${this.offer.category.name} ${this.offer.game.name} ${this.offer.name} ${this.offer.name_user} на GoBuffy.com. Система защиты покупателей GOBUFFY SHIELD, система споров, возврат средств, верификация продавцов и другие функции делают вашу покупку безопасной.`,
        },
        {
          hid: `keywords`,
          name: "keywords",
          content:
            this.offer.name +
            ", " +
            this.offer.name_user +
            ", " +
            this.offer.game.name +
            ", " +
            this.offer.category.name,
        },
      ],
    };
  },
  data() {
    return {
      backendUrl: process.env.backendUrl,
      offer: null,
      index: null,
      showMedia: false,
      chatUserInfo: null,
    };
  },
  computed: {
    ...mapGetters({
      user: "auth/getUser",
      isChatSocketConnected: 'chat/getIsSocketConnected'
    }),
    swiperOption() {
      return {
        slidesPerView: 3,
        spaceBetween: 16,
        freeMode: true,
        slidesOffsetAfter: this.lightboxMedia.length > 2 ? 240 : 0,
        loop: false,
      };
    },
    reviews() {
      return this.$store.state.reviews.reviews;
    },
    lightboxMedia: {
      cache: false,
      get() {
        let lightboxMedias = [];
        let backendUrl = process.env.backendUrl;
        if (this.offer && this.offer.media) {
          this.offer.media.forEach(function (item, index) {
            let src = item.file.url;
            let thumb = item.file.url;
            if (item.file.type != 3) {
              thumb =
                (item.file.is_upload == 1 ? backendUrl : "") +
                thumb.split("?")[0];
              src =
                (item.file.is_upload == 1 ? backendUrl : "") +
                src.split("?")[0];
            } else {
              let split = thumb.split("/");
              thumb =
                "https://img.youtube.com/vi/" +
                split[split.length - 1] +
                "/0.jpg";
            }
            let media = {
              src: src,
              thumb: thumb,
              description: item.file.title,
              type: item.file.type,
              file_id: item.file_id,
            };
            lightboxMedias = lightboxMedias.concat(media);
          });
        }

        return lightboxMedias;
      },
    },
  },
  watch: {
    "$route.query.reviewsPage": {
      handler: async function (page) {
        this.$route.query.filter = "type=2&to_user_id";
        await this.$store.dispatch("reviews/GET_REVIEWS", {
          userId: this.offer.user.id,
          query: this.$route.query,
        });
      },
      deep: true,
      immediate: true,
    },
    isChatSocketConnected: {
      handler: async function(isConnected) {
        if (isConnected) {
          try {
            this.chatUserInfo = await this.userChatInfo({
              userId: this.$store.state.auth.user.jti, 
              anotherUserId: Number(this.offer.user.id)
            })
          } catch (e) {}
        }
      }
    }
  },
  async asyncData({ store, params, error, query }) {
    let offerId = params.offer.substr(0, params.offer.indexOf("-"));
    let offerResponse;

    try {
      offerResponse = await axios.get(
        "/offers/" +
          offerId +
          "?expand=offerToAttrs,media,customAttrs,attrs,user,category,slugName,reviewsCount,game"
      );
    } catch (e) {
      return error({ statusCode: e.response.status });
    }

    let offer = offerResponse.data.data;

    let monthNames = [
      "января",
      "февраля",
      "марта",
      "апреля",
      "мая",
      "июня",
      "июля",
      "августа",
      "сентября",
      "октября",
      "ноября",
      "декабря",
    ];
    let date = new Date(offer.user.created_at * 1000);
    offer.user.created_at =
      monthNames[date.getMonth()] + " " + date.getFullYear();
    offer.user.photo = getPhoto(offer.user.id, offer.user.photo_uploaded_at);
    let attributeId;
    offer.totalTime = null;
    offer.totalPrice = null;
    /*
      for(let i = 0; i < rootState.offerListMain.offers.length; i++){
        if(rootState.offerListMain.offers[i].id == id){
          if(rootState.offerListMain.calculateCategory[offer.category_id]){
            offer.attrs = rootState.offerListMain.calculateCategory[offer.category_id]
          }
          else if(rootState.offerListMain.offers[i].calculateAttrs){
            offer.attrs = rootState.offerListMain.offers[i].calculateAttrs.slice();
          }
          offer.totalTime = rootState.offerListMain.offers[i].calculatedTime;
          offer.totalPrice = rootState.offerListMain.offers[i].calculatedPrice;
        }
      }
      */

    // Добавляем свойства для вычисляемых атрибутов
    offer.attrs = prepareAttributesCalculateOffer(offer.attrs);

    if (offer.user.photo != "") {
      offer.user.photo = process.env.backendUrl + offer.user.photo;
    }
    // Собираем атрибуты которые не должен заполнять покупатель
    offer.contentAttrs = contentAttributes(offer.offerToAttrs);
    offer.attrs = calculateAttributes({
      attrs: offer.attrs,
      offerToAttrs: offer.offerToAttrs,
    });

    // CUSTOM ATTRIBUTES
    for (let i = 0; i < offer.customAttrs.length; i++) {
      offer.customAttrs[i].value = "";
      offer.customAttrs[i].content = {};
      offer.customAttrs[i].content.checked = 0;
    }

    // GET REVIEWS

    query.filter = "type=2&to_user_id";
    await store.dispatch("reviews/GET_REVIEWS", {
      userId: offer.user.id,
      query: query,
    });

    for (let i = 0; i < offer.offerToAttrs.length; i++) {
      let offerAttr = offer.offerToAttrs[i];

      for (let n = 0; n < offer.attrs.length; n++) {
        let attrs = offer.attrs[n];

        if (offerAttr.attr.id == attrs.id) {
          // TYPE 0
          // Записываем значения для чекбокса
          if (attrs.type == 0) {
            attrs.value = offerAttr.price_formula;
            attrs.time = offerAttr.time_formula / 60;
            if (parseInt(offerAttr.value) === 1) {
              attrs.checked = 1;
            } else {
              attrs.checked = 0;
            }
          }

          // TYPE 1
          // Записываем значения range
          if (attrs.type == 1) {
            // Записываем значение для текстового инпута
            if (attrs.view == null) {
              attrs.value = offerAttr.value;
            }

            let itemsPriceArray;
            let itemsPrice;
            let itemsTimeArray;
            let itemsTime;
            // Парсим формулы цены и времени
            if (offerAttr.price_formula != null) {
              itemsPriceArray = offerAttr.price_formula.split(", ");
              itemsPrice = eval("({" + itemsPriceArray + "})");
            }
            if (offerAttr.time_formula != null) {
              itemsTimeArray = offerAttr.time_formula.split(", ");
              itemsTime = eval("({" + itemsTimeArray + "})");
            }
            for (let index in itemsTime) {
              itemsTime[index] = itemsTime[index] / 60;
            }
            // Если есть предопределенные значения (availableValues)
            if (offerAttr.attr.view == 3 && attrs.availableValues.length > 0) {
              let indexPrice = 0;
              let indexTime = 0;
              for (let key in itemsPrice) {
                if (offerAttr.attr.view == 3 && offerAttr.attr.type == 1) {
                  let keySplit = key.split(",");
                  let firstAvailable = parseInt(keySplit[0]);
                  let secondAvailable = parseInt(keySplit[1]);
                  if (firstAvailable) {
                    if (!attrs.availableValues[firstAvailable - 1].content) {
                      attrs.availableValues[firstAvailable - 1].content = {};
                    }

                    attrs.availableValues[firstAvailable - 1].content.price =
                      itemsPrice[key];
                    attrs.availableValues[firstAvailable - 1].content.time =
                      itemsTime[key];
                  }

                  if (secondAvailable) {
                    if (!attrs.availableValues[secondAvailable - 1].content) {
                      attrs.availableValues[secondAvailable - 1].content = {};
                    }

                    attrs.availableValues[secondAvailable - 1].content.price =
                      itemsPrice[key];
                    attrs.availableValues[secondAvailable - 1].content.time =
                      itemsTime[key];
                  }
                } else {
                  if (!attrs.availableValues[indexPrice].content) {
                    attrs.availableValues[indexPrice].content = {};
                  }
                  attrs.availableValues[indexPrice].content.price =
                    itemsPrice[key];
                  attrs.availableValues[indexTime].content.time =
                    itemsTime[key];
                  indexPrice++;
                  indexTime++;
                }
              }
            }

            // Если нет предопределенных значений записываем обычный range
            else {
              if (itemsPriceArray != undefined && itemsPriceArray.length != 0) {
                for (let key in itemsPrice) {
                  let range = key.split(",");
                  let time =
                    itemsTimeArray != undefined && itemsTimeArray.length != 0
                      ? itemsTime[key]
                      : null;
                  if (!attrs.range) {
                    attrs.range = Array();
                  }
                  attrs.range.push({
                    from: range[0],
                    to: range[1],
                    price: itemsPrice[key],
                    time: time,
                  });
                }
              } else {
                for (let key in itemsTime) {
                  let price =
                    itemsPriceArray != undefined && itemsPriceArray.length != 0
                      ? itemsPrice[key]
                      : null;
                  if (!attrs.range) {
                    attrs.range = Array();
                  }

                  let range = key.split(",");
                  attrs.range.push({
                    from: range[0],
                    to: range[1],
                    price: price,
                    time: itemsTime[key],
                  });
                }
              }
            }
          }

          // TYPE 2
          if (attrs.type == 2) {
            if (attrs.view == null) {
              attrs.value = offerAttr.value;
            }
          }

          // TYPE 3

          if (attrs.type == 3) {
            // MultiSelectNoFilled
            if (
              attrs.view == null ||
              (attrs.affects_price == 0 && attrs.affects_time == 0)
            ) {
              if (offerAttr.price_formula != null) {
                let itemsPrice = offerAttr.available_value_id
                  .replace("[", "")
                  .replace("]", "")
                  .split(",");
                for (
                  let index = 0;
                  index < attrs.availableValues.length;
                  index++
                ) {
                  for (
                    let indexAv = 0;
                    indexAv < itemsPrice.length;
                    indexAv++
                  ) {
                    if (
                      itemsPrice[indexAv] == attrs.availableValues[index].id
                    ) {
                      attrs.availableValues[index].check = 1;
                    }
                  }
                }
              }
            }
            // MultiSelect
            else {
              let itemsPrice;
              let itemsTime;
              if (offerAttr.price_formula != null) {
                itemsPrice = offerAttr.price_formula.split(", ");
                itemsPrice = eval("({" + itemsPrice + "})");
              }
              if (offerAttr.time_formula != null) {
                itemsTime = offerAttr.time_formula.split(", ");
                itemsTime = eval("({" + itemsTime + "})");
              }
              for (let index in itemsTime) {
                itemsTime[index] = itemsTime[index] / 60;
              }
              for (let k = 0; k < attrs.availableValues.length; k++) {
                if (
                  itemsPrice != undefined &&
                  itemsPrice[attrs.availableValues[k].id]
                ) {
                  let key = attrs.availableValues[k].id;
                  attrs.availableValues[k].check = 1;
                  if (!attrs.availableValues[k].content) {
                    attrs.availableValues[k].content = {};
                  }
                  attrs.availableValues[k].content.price = itemsPrice[key];
                }
                if (
                  itemsTime != undefined &&
                  itemsTime[attrs.availableValues[k].id]
                ) {
                  let key = attrs.availableValues[k].id;
                  attrs.availableValues[k].check = 1;
                  if (attrs.availableValues[k].content) {
                    attrs.availableValues[k].content = {};
                  }
                  attrs.availableValues[k].content.time = itemsTime[key];
                }
              }
            }
          }

          // TYPE 4
          if (attrs.type == 4) {
            attrs.value = offerAttr.available_value_id
              .replace("[", "")
              .replace("]", "");
          }
        }
      }
    }

    console.log("OFFER: ", offer);
    return {
      offer: offer,
    };
  },
  async mounted() {
    this.showMedia = true;

    try {
      this.chatUserInfo = await this.userChatInfo({
        userId: this.$store.state.auth.user.jti, 
        anotherUserId: Number(this.offer.user.id)
      })
    } catch (e) {}
  },
  methods: {
    ...mapActions({
      'userChatInfo': 'chat/SOCKET_GET_CHAT_ID'
    }),
    setIndex(index) {
      this.index = index;
    },
    handleUserChangeOnline(payload) {
      if (payload.isOnline == true) {
        this.chatUserInfo = null;
      } else {
        this.chatUserInfo = {
          anotherUser: {
            disconnectedAt: payload.disconnectedAt
          }
        }
      }
    }
  },
};
</script>

<style lang="scss" scoped>
@import "src/design/site/offer.scss";
.offer-content {
  max-width: 720px;
}

.offer-media {
  margin-top: 30px;
  margin-bottom: 15px;
  padding-left: 15px;
  width: 100%;
  .swiper-slide {
    min-width: 240px;
  }

  .offer-media-file {
    .svg-icon {
      display: none;
      position: absolute;
      width: 60px;
      height: 60px;
      left: calc(50% - 30px);
      top: calc(50% - 30px);
    }

    .svg-icon-video {
      position: absolute;
      width: 30px;
      height: 30px;
      left: 15px;
      bottom: 15px;
    }

    img {
      width: 240px;
      height: 145px;
      display: flex;
    }

    video {
      width: 240px;
      height: 145px;
      display: flex;
      background-color: black;
    }
  }

  .offer-media-file:hover {
    cursor: pointer;
    .svg-icon {
      display: block;
    }
  }
}

.swiper-slide {
  &:last-child {
    .swiper-link {
      &:after {
        display: none;
      }
    }
  }
}

.offer-user {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 11px 16px;
  font-size: 14px;
  background: #f7f9fc;
}
.user-content {
  display: flex;
  align-items: center;
  justify-content: flex-start;
}
.user-timings {
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  align-items: flex-end;
}
.user-avatar {
  margin-right: 10px;
  width: 32px;
  height: 32px;
  img {
    width: 100%;
    height: 100%;
    border-radius: 50%;
  }
}

.user-rating {
  position: relative;
  margin-left: 10px;
  margin-right: 16px;
  padding-left: 24px;
  padding-right: 7px;
  line-height: 22px;
  border-radius: 4px;
  background: $green;
  font-size: 12px;
  color: #ffffff;
  &:before {
    position: absolute;
    top: 4px;
    left: 7px;
    content: "";
    width: 14px;
    height: 13px;
    background: url("data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTQiIGhlaWdodD0iMTMiIHZpZXdCb3g9IjAgMCAxNCAxMyIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTAgMTNIMi41NDU0NVY1LjJIMFYxM1pNMTQgNS44NUMxNCA1LjEzNSAxMy40MjczIDQuNTUgMTIuNzI3MyA0LjU1SDguNzExODJMOS4zMTYzNiAxLjU3OTVMOS4zMzU0NSAxLjM3MTVDOS4zMzU0NSAxLjEwNSA5LjIyNzI3IDAuODU4IDkuMDU1NDUgMC42ODI1TDguMzgwOTEgMEw0LjE5MzY0IDQuMjgzNUMzLjk1ODE4IDQuNTE3NSAzLjgxODE4IDQuODQyNSAzLjgxODE4IDUuMlYxMS43QzMuODE4MTggMTIuNDE1IDQuMzkwOTEgMTMgNS4wOTA5MSAxM0gxMC44MTgyQzExLjM0NjQgMTMgMTEuNzk4MiAxMi42NzUgMTEuOTg5MSAxMi4yMDdMMTMuOTEwOSA3LjYyNDVDMTMuOTY4MiA3LjQ3NSAxNCA3LjMxOSAxNCA3LjE1VjUuODVaIiBmaWxsPSJ3aGl0ZSIvPgo8L3N2Zz4K");
  }
}

.user-feedback {
  margin-left: 15px;
}
.icon-feedback {
  margin-top: -2px;
  margin-right: 2px;
  fill: #666972;
  transition: $link-transition;
}
.user-time {
  font-size: $text-md;
  color: $grey;
  &:before {
    margin-right: 2px;
    margin-top: -2px;
    content: "";
    display: inline-block;
    vertical-align: middle;
    width: 14px;
    height: 16px;
    background: url("data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTQiIGhlaWdodD0iMTYiIHZpZXdCb3g9IjAgMCAxNCAxNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTEyLjI1IDIuMjVIMTEuNVYwLjc1SDEwVjIuMjVINFYwLjc1SDIuNVYyLjI1SDEuNzVDMC45MTc1IDIuMjUgMC4yNTc1IDIuOTI1IDAuMjU3NSAzLjc1TDAuMjUgMTQuMjVDMC4yNSAxNS4wNzUgMC45MTc1IDE1Ljc1IDEuNzUgMTUuNzVIMTIuMjVDMTMuMDc1IDE1Ljc1IDEzLjc1IDE1LjA3NSAxMy43NSAxNC4yNVYzLjc1QzEzLjc1IDIuOTI1IDEzLjA3NSAyLjI1IDEyLjI1IDIuMjVaTTEyLjI1IDE0LjI1SDEuNzVWNkgxMi4yNVYxNC4yNVpNMy4yNSA3LjVIN1YxMS4yNUgzLjI1VjcuNVoiIGZpbGw9IiM2RTcyNzkiLz4KPC9zdmc+Cg==");
  }
}

.user-disconnected-at {
  font-size: $text-md;
  color: $grey;
}

.properties {
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  padding: 3px 16px;
  font-size: 14px;
  font-weight: 500;
}
.property {
  position: relative;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  width: 48%;
  padding: 12px 1px;
  justify-content: space-between;
  border-bottom: 1px solid #eff1f4;
  span {
    width: 50%;
    font-weight: 400;
    color: #6e7279;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  &.property-100 {
    width: 100%;
  }
}

.description {
  padding: 20px 16px;
  font-size: 14px;
  line-height: 25px;
  font-weight: 500;
  p {
    margin-bottom: 8px;
  }
}

.tags {
  display: flex;
  justify-content: flex-start;
  margin-top: 47px;
  padding: 16px;
}
.tag {
  position: relative;
  width: 192px;
  height: 64px;
  padding-left: 67px;
  padding-right: 10px;
  display: flex;
  align-items: center;
  border-radius: 4px;
  font-size: 14px;
  line-height: 17px;
  font-weight: 500;
  & + & {
    margin-left: 16px;
  }
  &.tag-red {
    background: rgba($red, 0.1);
    .icon-tag {
      fill: $red;
    }
  }
  &.tag-green {
    background: rgba($green, 0.1);
    .icon-tag {
      fill: $green;
    }
  }
  &.tag-orange {
    background: rgba($orange, 0.1);
    .icon-tag {
      fill: $orange;
    }
  }
}
.tag-icon {
  position: absolute;
  top: 0;
  left: 0;
  width: 67px;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.block {
  margin-top: 16px;
  padding-bottom: 16px;
  border-radius: 4px;
  background: #ffffff;
}
.block-head {
  margin-bottom: 16px;
  display: flex;
  justify-content: space-between;
  padding-top: 25px;
  padding-bottom: 21px;
  padding-left: 16px;
  padding-right: 16px;
  border-bottom: 2px solid #eff1f4;
  h2 {
    margin: 0;
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    justify-content: flex-start;
    font-size: 20px;
    font-weight: 500;
    span {
      margin-left: 8px;
      color: #6a6e76;
      font-weight: 500;
    }
  }
}

.icon-block {
  margin-right: 19px;
  fill: $blue;
}

.reviews {
  margin-top: 32px;
  background: #ffffff;
}

.review {
  position: relative;
  padding-left: 87px;
  padding-right: 255px;
  padding-top: 21px;
  padding-bottom: 18px;
  border-bottom: 2px solid #eff1f4;
}
.review-rating {
  position: absolute;
  top: 26px;
  left: 0;
  width: 87px;
  padding-left: 21px;
  text-align: center;
  span {
    position: relative;
    display: inline-block;
    margin-left: 10px;
    margin-right: 16px;
    padding-left: 24px;
    padding-right: 7px;
    line-height: 22px;
    border-radius: 4px;
    background: $green;
    font-size: 12px;
    color: #ffffff;
    &:before {
      position: absolute;
      top: 4px;
      left: 7px;
      content: "";
      width: 14px;
      height: 13px;
      background: url("data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTQiIGhlaWdodD0iMTMiIHZpZXdCb3g9IjAgMCAxNCAxMyIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTAgMTNIMi41NDU0NVY1LjJIMFYxM1pNMTQgNS44NUMxNCA1LjEzNSAxMy40MjczIDQuNTUgMTIuNzI3MyA0LjU1SDguNzExODJMOS4zMTYzNiAxLjU3OTVMOS4zMzU0NSAxLjM3MTVDOS4zMzU0NSAxLjEwNSA5LjIyNzI3IDAuODU4IDkuMDU1NDUgMC42ODI1TDguMzgwOTEgMEw0LjE5MzY0IDQuMjgzNUMzLjk1ODE4IDQuNTE3NSAzLjgxODE4IDQuODQyNSAzLjgxODE4IDUuMlYxMS43QzMuODE4MTggMTIuNDE1IDQuMzkwOTEgMTMgNS4wOTA5MSAxM0gxMC44MTgyQzExLjM0NjQgMTMgMTEuNzk4MiAxMi42NzUgMTEuOTg5MSAxMi4yMDdMMTMuOTEwOSA3LjYyNDVDMTMuOTY4MiA3LjQ3NSAxNCA3LjMxOSAxNCA3LjE1VjUuODVaIiBmaWxsPSJ3aGl0ZSIvPgo8L3N2Zz4K");
    }
  }
}
.review-user {
  position: absolute;
  top: 21px;
  right: 0;
  width: 255px;
  padding-left: 43px;
  font-size: 14px;
  color: #6e7279;
  line-height: 1.4;
  span {
    display: block;
    font-size: 12px;
  }
}
.review-content {
  font-size: 14px;
  color: #2d303a;
}
.review-title {
  font-size: 12px;
  color: #a8aaaf;
  a {
    margin-right: 21px;
    color: #a8aaaf;
  }
}
.review-user-avatar {
  position: absolute;
  top: 0;
  left: 0;
  width: 34px;
  height: 34px;
  img {
    width: 100%;
    height: 100%;
    border-radius: 50%;
  }
}

.reviews-more {
  padding: 23px 16px 2px;
  font-size: 14px;
  color: #a8aaaf;
  a {
    margin-right: 21px;
    width: 155px;
    padding: 0;
    line-height: 38px;
    font-size: 14px;
    font-weight: 500;
    color: #2d303a;
    &:hover {
      color: #ffffff;
    }
  }
}
.rating {
  margin-left: 10px;
}
.icon-balance {
  margin-right: 2px;
  margin-top: -4px;
  display: inline-block;
  vertical-align: middle;
  fill: $blue;
}

.seller-rating {
  margin-right: 14px;
  display: flex;
  flex-direction: column;
  align-self: center;
}

.time-instantly {
  &:before {
    margin-right: 5px;
    display: inline-block;
    vertical-align: middle;
    width: 10px;
    height: 20px;
    content: "";
    background: url("data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTAiIGhlaWdodD0iMjAiIHZpZXdCb3g9IjAgMCAxMCAyMCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggb3BhY2l0eT0iMC43IiBkPSJNMCAwVjExSDNWMjBMMTAgOEg2TDEwIDBIMFoiIGZpbGw9IiNGRkIwMDAiLz4KPC9zdmc+Cg==");
  }
}

.offer-header {
  padding: 20px 10px;
  font-size: 14px;
  line-height: 25px;
  font-weight: 500;
  align-items: center;
  img {
    width: 32px;
    height: 32px;
    margin-right: 16px;
  }
  h1 {
    padding: 0;
  }
}
</style>
